// removes prefix igfd:taxnomytype: from the id
const cleanIgfdIds = (igfdId: string) =>
  // split by : and remove the first two elements
  igfdId.split(":").slice(2).join(":");

// Returns a slug from a name
// keeps only alphanumeric characters and replaces spaces with dashes
const nameSlug = (name: string) =>
  name.replace(/[^a-zA-Z0-9]/g, "-").toLowerCase();

// The action names defined here are used
// in for datadog dashboards to track the user actions.
export const DatadogActionNames = {
  showMayContainAllergenSwitch: "show-may-contain-allergens",
  showCaloriesSwitch: "show-calories",
  showAllergenDetailsSwitch: "show-allergen-details",

  filterMenuDrawerOpen: "open-filter-menu-drawer",
  filterMenuDrawerDoneButton: "do-filter-menu-button", // selection of dietary restrictions done, do the filtering.
  ingredientFilteringRequested: "ingredient-filter-requested",

  allergenChipSelectedForFiltering: (igfdTaxAllergenId: string) =>
    `allergen-filter-${cleanIgfdIds(igfdTaxAllergenId)}`,

  preferenceChipSelectedForFiltering: (igfdTaxPreferenceId: string) =>
    `preference-filter-${cleanIgfdIds(igfdTaxPreferenceId)}`,

  ingredientChipSelectedForFiltering: (igfdTaxIngredientId: string) =>
    `ingredient-filter-${cleanIgfdIds(igfdTaxIngredientId)}`,

  tagSelectedForFiltering: (tagId: string) =>
    `tag-filter-${cleanIgfdIds(tagId)}`,

  dishSelected: (dishName: string) => `dish-selected-${nameSlug(dishName)}`,
};

export type TDatadogActionNames = typeof DatadogActionNames;
